"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _range = _interopRequireDefault(require("lodash/range"));
/**
 * This function returns the rating based on the rating internal, rating limit and number of intervals
 */
function getRatings(minRatingValue, ratingInterval, numberOfIntervals) {
  var ratings = [];
  (0, _range["default"])(0, numberOfIntervals).forEach(function (rating) {
    ratings.push(minRatingValue + rating * ratingInterval);
  });
  return ratings;
}
var _default = exports["default"] = getRatings;
//# sourceMappingURL=getRatings.js.map